import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useContext, useMemo } from 'react';
import { useCaptcha, useCaptchaActions, useCaptchaMessages } from "../../../lib";
var CaptchaContext = /*#__PURE__*/createContext({
  sendCaptchaMessage: function sendCaptchaMessage() {
    return new Promise(function () {});
  },
  createCaptcha: function createCaptcha() {
    return new Promise(function () {});
  },
  handleChangeStage: function handleChangeStage() {
    return new Promise(function () {});
  },
  generateCaptchaMessage: function generateCaptchaMessage() {
    return new Promise(function () {});
  },
  captchaUpdate: function captchaUpdate() {
    return new Promise(function () {});
  },
  captchaStage: 'init'
});
export var CaptchaProvider = function CaptchaProvider(_ref) {
  var children = _ref.children,
    updateMessage = _ref.updateMessage,
    config = _ref.config,
    addMessage = _ref.addMessage,
    _ref$reconnectCount = _ref.reconnectCount,
    reconnectCount = _ref$reconnectCount === void 0 ? 0 : _ref$reconnectCount,
    setIsNoNAuthCaptchaStage = _ref.setIsNoNAuthCaptchaStage;
  var _useCaptchaActions = useCaptchaActions(updateMessage, config),
    createCaptcha = _useCaptchaActions.createCaptcha,
    validateCaptcha = _useCaptchaActions.validateCaptcha,
    captchaUpdate = _useCaptchaActions.captchaUpdate;
  var generateCaptchaMessage = useCaptchaMessages({
    updateMessage: updateMessage,
    addMessage: addMessage,
    createCaptcha: createCaptcha
  });
  var params = useCaptcha({
    config: config,
    reconnectCount: reconnectCount,
    generateCaptchaMessage: generateCaptchaMessage,
    validateCaptcha: validateCaptcha,
    setIsNoNAuthCaptchaStage: setIsNoNAuthCaptchaStage
  });
  var value = useMemo(function () {
    return _objectSpread(_objectSpread({}, params), {}, {
      createCaptcha: createCaptcha,
      generateCaptchaMessage: generateCaptchaMessage,
      captchaUpdate: captchaUpdate
    });
  }, [params, generateCaptchaMessage, createCaptcha, captchaUpdate]);
  return /*#__PURE__*/React.createElement(CaptchaContext.Provider, {
    value: value
  }, children);
};
export var useCaptchaContext = function useCaptchaContext() {
  return useContext(CaptchaContext);
};